import React, { useState } from "react";

const SIZE = {
  sm: "h-8 w-8 text-xs",
  md: "h-9 w-9 text-xs",
  lg: "h-11 w-11 text-sm",
};

export const MemberAvatar = ({ name, email, picture, size = "md", className = "", testId }) => {
  const [failed, setFailed] = useState(false);
  const initial = (name || email || "?").trim().slice(0, 1).toUpperCase() || "?";
  const base = `${SIZE[size] || SIZE.md} rounded-full shrink-0 ${className}`;

  if (picture && !failed) {
    return (
      <img
        src={picture}
        alt={name || email || "member"}
        referrerPolicy="no-referrer"
        onError={() => setFailed(true)}
        className={`${base} object-cover bg-slate-100`}
        data-testid={testId}
      />
    );
  }
  return (
    <div
      className={`${base} bg-blue-600 text-white flex items-center justify-center font-semibold`}
      data-testid={testId}
    >
      {initial}
    </div>
  );
};

export default MemberAvatar;
